// extracted by mini-css-extract-plugin
export default {"swipperContainer":"swipper_swipperContainer__Feoxm","leftArrow":"swipper_leftArrow__FgDPm","title":"swipper_title__5-PY8"};